// Test IDs for the Wealth Academy features.
export const NAV = {
  logoLink: 'nav-logo-link',
  coursesLink: 'nav-courses-link',
  articlesLink: 'nav-articles-link',
  pricingLink: 'nav-pricing-link',
  dashboardLink: 'nav-dashboard-link',
  loginButton: 'nav-login-button',
  registerButton: 'nav-register-button',
  logoutButton: 'nav-logout-button',
  accountLink: 'nav-account-link',
  mobileToggle: 'nav-mobile-toggle',
  languageSelector: 'nav-language-selector',
  languageOption: 'nav-language-option',
};

export const LANDING = {
  hero: 'landing-hero',
  heroCtaPrimary: 'landing-hero-cta-primary',
  heroCtaSecondary: 'landing-hero-cta-secondary',
  pricingCta: 'landing-pricing-cta',
  featuresSection: 'landing-features-section',
  featureCard: 'landing-feature-card',
  partnersSection: 'landing-partners-section',
  partnerLogo: 'landing-partner-logo',
  socialLinks: 'landing-social-links',
  socialLink: 'landing-social-link',
  testimonialCarousel: 'landing-testimonial-carousel',
  testimonialSlide: 'landing-testimonial-slide',
  testimonialPrev: 'landing-testimonial-prev',
  testimonialNext: 'landing-testimonial-next',
  testimonialDot: 'landing-testimonial-dot',
};

export const PRICING = {
  root: 'pricing-root',
  cardFree: 'pricing-card-free',
  cardBasic: 'pricing-card-basic',
  cardPremium: 'pricing-card-premium',
  subscribeBasic: 'pricing-subscribe-basic',
  subscribePremium: 'pricing-subscribe-premium',
};

export const DASHBOARD = {
  root: 'dashboard-root',
  greeting: 'dashboard-greeting',
  continueCard: 'dashboard-continue-card',
  metricLessons: 'dashboard-metric-lessons',
  metricTier: 'dashboard-metric-tier',
  metricStreak: 'dashboard-metric-streak',
  metricGrade: 'dashboard-metric-grade',
  sidebarOverview: 'dashboard-sidebar-overview',
  sidebarCourses: 'dashboard-sidebar-courses',
  sidebarArticles: 'dashboard-sidebar-articles',
  sidebarResources: 'dashboard-sidebar-resources',
  sidebarAiCoach: 'dashboard-sidebar-ai-coach',
  sidebarAccount: 'dashboard-sidebar-account',
  firstWeekPreview: 'dashboard-first-week-preview',
  firstWeekDay: 'dashboard-first-week-day',
  firstWeekCta: 'dashboard-first-week-cta',
  onboardingChecklist: 'dashboard-onboarding-checklist',
  onboardingDismiss: 'dashboard-onboarding-dismiss',
  onboardingItem: 'dashboard-onboarding-item',
  onboardingDiscord: 'dashboard-onboarding-discord',
};

export const TOUR = {
  root: 'onboarding-tour',
  restartButton: 'onboarding-tour-restart-button',
};

export const COURSES = {
  root: 'courses-root',
  card: 'courses-card',
};

export const COURSE_DETAIL = {
  root: 'course-detail-root',
  chapter: 'course-chapter',
  lessonRow: 'course-lesson-row',
  lessonLock: 'course-lesson-lock',
  freePreviewBadge: 'course-lesson-free-preview',
  quizButton: 'course-quiz-button',
  freeUpsell: 'course-free-upsell',
  sequentialInfo: 'course-sequential-info',
};

export const QUIZ = {
  root: 'quiz-root',
  question: 'quiz-question',
  option: 'quiz-option',
  submitButton: 'quiz-submit-button',
  resultScore: 'quiz-result-score',
  retakeButton: 'quiz-retake-button',
  backButton: 'quiz-back-button',
};

export const LESSON = {
  root: 'lesson-root',
  video: 'lesson-video',
  markComplete: 'lesson-mark-complete-button',
  tabsOverview: 'lesson-tab-overview',
  tabsTranscript: 'lesson-tab-transcript',
  tabsResources: 'lesson-tab-resources',
  brokerCta: 'lesson-broker-cta',
};

export const AI_COACH = {
  root: 'ai-coach-root',
  input: 'ai-coach-input',
  sendButton: 'ai-coach-send-button',
  messagesContainer: 'ai-coach-messages',
  lockedNotice: 'ai-coach-locked-notice',
  suggestion: 'ai-coach-suggestion',
  basicNudge: 'ai-coach-basic-nudge',
  basicNudgeCta: 'ai-coach-basic-nudge-cta',
  basicUpgradeCta: 'ai-coach-basic-upgrade-cta',
  // Multimodal + Whiteboard mode
  attachButton: 'ai-coach-attach-btn',
  attachInput: 'ai-coach-attach-input',
  attachChip: 'ai-coach-attach-chip',
  attachRemove: 'ai-coach-attach-remove',
  whiteboardToggle: 'ai-coach-whiteboard-toggle',
  whiteboardSlot: 'ai-coach-whiteboard-slot',
  symbolSelect: 'ai-coach-symbol-select',
  coachModeToggle: 'ai-coach-coach-mode-toggle',
  socraticSkip: 'ai-coach-socratic-skip',
  saveToJournal: 'ai-coach-save-to-journal',
  saveDialog: 'ai-coach-save-dialog',
  saveDialogSubmit: 'ai-coach-save-dialog-submit',
  disclaimerModal: 'ai-coach-disclaimer-modal',
  disclaimerAccept: 'ai-coach-disclaimer-accept',
};

export const WAITLIST = {
  root: 'waitlist-root',
  nameInput: 'waitlist-name-input',
  emailInput: 'waitlist-email-input',
  languageSelect: 'waitlist-language-select',
  interestInput: 'waitlist-interest-input',
  submitButton: 'waitlist-submit-button',
  successMessage: 'waitlist-success-message',
};

export const CERTIFICATE = {
  root: 'certificate-root',
  printButton: 'certificate-print-button',
  backButton: 'certificate-back-button',
  listRoot: 'certificates-list-root',
  listCard: 'certificates-list-card',
  masterCard: 'certificates-master-card',
  masterProgress: 'certificates-master-progress',
  masterIssueButton: 'certificates-master-issue-button',
  masterViewButton: 'certificates-master-view-button',
};

export const ACCOUNT = {
  root: 'account-root',
  cancelButton: 'account-cancel-button',
  upgradeButton: 'account-upgrade-button',
  languageSelect: 'account-language-select',
  languageSaveButton: 'account-language-save-button',
};

export const PAYMENT = {
  root: 'payment-return-root',
  statusText: 'payment-return-status',
};

export const AGREEMENT = {
  root: 'agreement-root',
  tierLabel: 'agreement-tier-label',
  scrollBody: 'agreement-scroll-body',
  checkRisk: 'agreement-check-risk',
  checkNoRefund: 'agreement-check-no-refund',
  checkNotAdvice: 'agreement-check-not-advice',
  fullNameInput: 'agreement-full-name-input',
  signButton: 'agreement-sign-button',
  cancelButton: 'agreement-cancel-button',
  freeAccountLink: 'agreement-free-account-link',
};

export const GRACE = {
  banner: 'grace-banner',
  countdown: 'grace-countdown',
  cancelButton: 'grace-cancel-button',
};

export const ADMIN = {
  root: 'admin-root',
  statCard: 'admin-stat-card',
  tabWaitlist: 'admin-tab-waitlist',
  tabAgreements: 'admin-tab-agreements',
  waitlistRow: 'admin-waitlist-row',
  agreementRow: 'admin-agreement-row',
  csvWaitlist: 'admin-csv-waitlist',
  csvAgreements: 'admin-csv-agreements',
  searchInput: 'admin-search-input',
  tierFilter: 'admin-tier-filter',
};

export const RESOURCES = {
  root: 'resources-root',
  funnelPreview: 'resources-funnel-preview',
  tabCalendar: 'resources-tab-calendar',
  tabBrokers: 'resources-tab-brokers',
  tabSoftware: 'resources-tab-software',
  tabCalculator: 'resources-tab-calculator',
  tabJournal: 'resources-tab-journal',
  tabDownloads: 'resources-tab-downloads',
  tabClimb: 'resources-tab-climb',
  tabGrader: 'resources-tab-grader',
  calendarFrame: 'resources-calendar-frame',
  brokerCard: 'resources-broker-card',
  propFirmCard: 'resources-prop-firm-card',
  propFirmsSection: 'resources-prop-firms-section',
  riskWarning: 'resources-risk-warning',
  softwareCard: 'resources-software-card',
  copyCodeButton: 'resources-copy-code-button',
  // Calculator
  calcEquity: 'resources-calc-equity',
  calcRisk: 'resources-calc-risk',
  calcRiskModeDollar: 'resources-calc-risk-mode-dollar',
  calcRiskModePercent: 'resources-calc-risk-mode-percent',
  calcEntry: 'resources-calc-entry',
  calcStop: 'resources-calc-stop',
  calcTarget: 'resources-calc-target',
  calcPipSize: 'resources-calc-pip-size',
  calcResult: 'resources-calc-result',
  calcResultPips: 'resources-calc-result-pips',
  calcResultDollarRisk: 'resources-calc-result-dollar-risk',
  calcResultRiskPct: 'resources-calc-result-risk-pct',
  // Journal
  journalStats: 'resources-journal-stats',
  journalAddButton: 'resources-journal-add-button',
  journalInstrument: 'resources-journal-instrument',
  journalDirection: 'resources-journal-direction',
  journalEntry: 'resources-journal-entry',
  journalExit: 'resources-journal-exit',
  journalSize: 'resources-journal-size',
  journalPnl: 'resources-journal-pnl',
  journalR: 'resources-journal-r',
  journalNotes: 'resources-journal-notes',
  journalSaveButton: 'resources-journal-save-button',
  journalRow: 'resources-journal-row',
  journalEditButton: 'resources-journal-edit-button',
  journalExpandButton: 'resources-journal-expand-button',
  journalImageUpload: 'resources-journal-image-upload',
  journalImageThumb: 'resources-journal-image-thumb',
  journalImageDelete: 'resources-journal-image-delete',
  journalUpdateInput: 'resources-journal-update-input',
  journalUpdateAddButton: 'resources-journal-update-add-button',
  journalDeleteButton: 'resources-journal-delete-button',
  // Weekly report
  weeklyReportOpen: 'resources-weekly-report-open',
  weeklyReportClose: 'resources-weekly-report-close',
  weeklyReportContent: 'resources-weekly-report-content',
  weeklyReportDownload: 'resources-weekly-report-download',
  weeklyReportRegenerate: 'resources-weekly-report-regenerate',
  pastReportsSection: 'resources-past-reports',
  pastReportRow: 'resources-past-report-row',
  pastReportDownload: 'resources-past-report-download',
  // Journal — account & plan dropdowns
  journalAccount: 'resources-journal-account',
  journalClimbPlan: 'resources-journal-climb-plan',
  // Webinars tab trigger
  tabWebinars: 'resources-tab-webinars',
};

export const WEBINARS = {
  root: 'webinars-root',
  liveBanner: 'webinars-live-banner',
  liveJoinButton: 'webinars-live-join-button',
  nextCard: 'webinars-next-card',
  library: 'webinars-library',
  card: 'webinars-card',
  searchInput: 'webinars-search-input',
  sortSelect: 'webinars-sort-select',
  tagChip: 'webinars-tag-chip',
  clearFilters: 'webinars-clear-filters',
  bookmarkButton: 'webinars-bookmark-button',
  discordCta: 'webinars-discord-cta',
  discordButton: 'webinars-discord-button',
  playerModal: 'webinars-player-modal',
  playerClose: 'webinars-player-close',
  playerLiveLink: 'webinars-player-live-link',
};

export const WEBINARS_ADMIN = {
  root: 'admin-webinars-root',
  newButton: 'admin-webinars-new-button',
  row: 'admin-webinars-row',
  editButton: 'admin-webinars-edit-button',
  deleteButton: 'admin-webinars-delete-button',
  toggleLive: 'admin-webinars-toggle-live',
  formModal: 'admin-webinars-form-modal',
  formTitle: 'admin-webinars-form-title',
  formDescription: 'admin-webinars-form-description',
  formTags: 'admin-webinars-form-tags',
  formVimeo: 'admin-webinars-form-vimeo',
  formLiveUrl: 'admin-webinars-form-live-url',
  formDuration: 'admin-webinars-form-duration',
  formRecordedAt: 'admin-webinars-form-recorded-at',
  formScheduledAt: 'admin-webinars-form-scheduled-at',
  formThumbnail: 'admin-webinars-form-thumbnail',
  formStatus: 'admin-webinars-form-status',
  formPinned: 'admin-webinars-form-pinned',
  formNotes: 'admin-webinars-form-notes',
  formAddResource: 'admin-webinars-form-add-resource',
  formSave: 'admin-webinars-form-save',
};

export const SECURITY_ADMIN = {
  root: 'admin-security-root',
  search: 'admin-security-search',
  row: 'admin-security-row',
  reviewButton: 'admin-security-review-button',
  detailModal: 'admin-security-detail-modal',
  suspendButton: 'admin-security-suspend-button',
  unsuspendButton: 'admin-security-unsuspend-button',
  revokeAllButton: 'admin-security-revoke-all-button',
};

export const CLIMB = {
  root: 'climb-root',
  newPlanButton: 'climb-new-plan-button',
  planCard: 'climb-plan-card',
  formName: 'climb-form-name',
  formAccount: 'climb-form-account',
  formStart: 'climb-form-start',
  formTarget: 'climb-form-target',
  formRiskType: 'climb-form-risk-type',
  formRiskValue: 'climb-form-risk-value',
  formReward: 'climb-form-reward',
  formMode: 'climb-form-mode',
  formWinRate: 'climb-form-win-rate',
  formTimeline: 'climb-form-timeline',
  formPreview: 'climb-form-preview',
  formSubmit: 'climb-form-submit',
  formCancel: 'climb-form-cancel',
  planDetail: 'climb-plan-detail',
  planProgress: 'climb-plan-progress',
  planTrades: 'climb-plan-trades',
  planDelete: 'climb-plan-delete',
  planClose: 'climb-plan-close',
  accountsManage: 'climb-accounts-manage',
  accountRow: 'climb-account-row',
  accountAdd: 'climb-account-add',
  accountDelete: 'climb-account-delete',
};

export const GRADER = {
  root: 'grader-root',
  instrument: 'grader-instrument',
  direction: 'grader-direction',
  setupType: 'grader-setup-type',
  bias: 'grader-bias',
  level: 'grader-level',
  fib: 'grader-fib',
  pattern: 'grader-pattern',
  maPosition: 'grader-ma-position',
  higherTf: 'grader-higher-tf',
  volume: 'grader-volume',
  rr: 'grader-rr',
  notes: 'grader-notes',
  reset: 'grader-reset',
  saveToJournal: 'grader-save-to-journal',
  scoreCard: 'grader-score-card',
  scoreGrade: 'grader-score-grade',
  scoreNumber: 'grader-score-number',
  breakdownRow: 'grader-breakdown-row',
  warning: 'grader-warning',
};
